import React from 'react'
import PropTypes from 'prop-types'
import FormItem from './FormItem'
import {
  SEARCH_PARAM_CLIENT_CODE,
  SEARCH_PARAM_CONTRACT_NUMBER,
  SEARCH_PARAM_IATA_CODE,
  SEARCH_PARAM_PROMO_CODE,
} from '../../../../constants'

const CodeForm = ({
                    labels, placeholders, codeChange, activeField, values, validate, syncErrors, clearInput,
                  }) => (
  <React.Fragment>
    <div className="code-form">
      <FormItem
        validationError={values !== null ? (!!values.error && values[SEARCH_PARAM_CLIENT_CODE] !== '') : false}
        clearInput={clearInput}
        label={labels[SEARCH_PARAM_CLIENT_CODE]}
        field={{
          name: SEARCH_PARAM_CLIENT_CODE,
          value: values && values[SEARCH_PARAM_CLIENT_CODE],
          placeholder: placeholders[SEARCH_PARAM_CLIENT_CODE],
          onChange: codeChange,
          active: activeField === SEARCH_PARAM_CLIENT_CODE,
          error: syncErrors && syncErrors[SEARCH_PARAM_CLIENT_CODE],
          clearInput: {clearInput},
        }}
      />
      <FormItem
        validationError={values !== null ?
          (!!values.error && values[SEARCH_PARAM_CONTRACT_NUMBER] !== '' ||
            values[SEARCH_PARAM_CLIENT_CODE] !== '' && values[SEARCH_PARAM_CONTRACT_NUMBER] ==='')
          : false}
        clearInput={clearInput}
        field={{
          name: SEARCH_PARAM_CONTRACT_NUMBER,
          value: values && values[SEARCH_PARAM_CONTRACT_NUMBER],
          placeholder: `${values && values[SEARCH_PARAM_CLIENT_CODE] ? '*' : ''}${placeholders[SEARCH_PARAM_CONTRACT_NUMBER]}`,
          onChange: codeChange,
          active: activeField === SEARCH_PARAM_CONTRACT_NUMBER,
          error: values && values[SEARCH_PARAM_CLIENT_CODE] !== '' && values[SEARCH_PARAM_CONTRACT_NUMBER] ==='' ? 'required'  : syncErrors && syncErrors[SEARCH_PARAM_CONTRACT_NUMBER],
          clearInput: {clearInput},
        }}
        validate={validate}
      />
      <FormItem
        validationError={ values !== null ? (
          values.errorPromo && values[SEARCH_PARAM_CLIENT_CODE] === '' && values[SEARCH_PARAM_CONTRACT_NUMBER] === ''
          || !!(!values.error && values.wrongPromoCode)
        ) : false}
        label={labels[SEARCH_PARAM_PROMO_CODE]}
        clearInput={clearInput}
        field={{
          name: SEARCH_PARAM_PROMO_CODE,
          value: values && values[SEARCH_PARAM_PROMO_CODE],
          placeholder: placeholders[SEARCH_PARAM_PROMO_CODE],
          onChange: codeChange,
          active: activeField === SEARCH_PARAM_PROMO_CODE,
          error: syncErrors && syncErrors[SEARCH_PARAM_PROMO_CODE],
        }}
      />

    </div>
    <div className="code-form__errors">

        <div className="filter-code__sub-title filter-code__error">
          {values && values.error && (values[SEARCH_PARAM_CLIENT_CODE] !== '' || values[SEARCH_PARAM_CONTRACT_NUMBER] !== '') ? (
            <React.Fragment>
              <span className={'input-error-attention'}>
                  <svg aria-labelledby="icon-error">
                  <use xlinkHref="#icon-error" />
                </svg>
              </span>
              <span>{values.error}</span>
            </React.Fragment>
          ) : null}
        </div>

        <div className="filter-code__sub-title filter-code__error">

          {(
            (values && values.errorPromo && values[SEARCH_PARAM_PROMO_CODE]) ||
            (values && values.wrongPromoCodeMessage && values.wrongPromoCode)
          ) &&  (
            <React.Fragment>
              <span className={'input-error-attention'}>
                  <svg aria-labelledby="icon-error">
                  <use xlinkHref="#icon-error" />
                </svg>
              </span>
                <span>{values.errorPromo || values.wrongPromoCodeMessage}</span>
            </React.Fragment>
          )}
        </div>
    </div>
  </React.Fragment>
)


CodeForm.propTypes = {
  codeChange: PropTypes.func.isRequired,
  labels: PropTypes.objectOf(PropTypes.string).isRequired,
  placeholders: PropTypes.objectOf(PropTypes.string).isRequired,
  activeField: PropTypes.string,
  values: PropTypes.objectOf(Object),
  validate: PropTypes.arrayOf(PropTypes.func),
  syncErrors: PropTypes.objectOf(PropTypes.string),
  clearInput: PropTypes.func.isRequired,
}

CodeForm.defaultProps = {
  activeField: '',
  values: null,
  validate: [],
  syncErrors: null,
}
export default CodeForm
